import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { SubdomainService } from "src/app/core/_base/subdomain.service";
import { MadAuthService } from "src/app/core/mad-auth/mad-auth.service";
import { environment } from "src/environments/environment";
import { ValuationComparableFilter } from "src/app/core/valuation-process/_actions/valuation-comparable.actions";
import { Observable } from "rxjs";
import { ValuationComparableMapData } from "src/app/core/valuation-process/_models";
import { VComparable } from "./types/asset-class/comparable";
import { mapFullRemoteToDomain, mapRemoteToDomain, mapTPRemoteToTpModel, ValuationComparableFullRemoteData, ValuationComparableRemoteData } from "../valuation/mapper/valuation-process";

@Injectable({
  providedIn: 'root'
})
export class ValuationProcessService {
  constructor(
    private http: HttpClient,
    private authService: MadAuthService,
    private subDomainService: SubdomainService
  ) { }

  fetch(valuationId: number) {
    return this.http.get<{ data: any, meta: any }>(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/valuation-process/${valuationId}`,
      {
        headers: this.authService.getAuthHeaders()
      }
    ).pipe(
      map(response => {
        return {
          data: response.data,
          selectedComparables: response.data.selected_comparables.map(item => mapFullRemoteToDomain(item)),
          targetProperty: mapTPRemoteToTpModel(response.meta.targetProperty),
          valuation: response.meta.valuation,
          additional: response.meta.additional,
          assumptionDepartures: response.meta.assumptionDepartures,
          vpga10Matters: response.meta.vpga10_matters,
          sers: response.meta.sers,
          notes: response.meta.notes,
          propertySubTypeIds: response.meta.property_sub_types
        }
      })
    )
  }

  loadComparables(filter: ValuationComparableFilter): Observable<ValuationComparableMapData[]> {
    const headers = this.authService.getAuthHeaders()
    const url = `${environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/valuation-process`}/comparables`
    return this.http.post<{ data: ValuationComparableRemoteData[] }>(url, { filter }, { headers })
      .pipe(
        map(response => response.data),
        map(response => {
          return response.map(res => mapRemoteToDomain(res)).filter(item => item != null)
        })
      )
  }

  loadFullComparables(refNums: string[]): Observable<VComparable[]> {
    const headers = this.authService.getAuthHeaders()
    const url = `${environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/valuation-process`}/full-comparables`
    const params = new HttpParams().set('refNums', refNums.join(','))
    return this.http.get<{ data: ValuationComparableFullRemoteData[] }>(url, { headers, params: params })
      .pipe(
        map(response => response.data),
        map(response => {
          return response.map(res => mapFullRemoteToDomain(res)).filter(item => item != null)
        })
      )
  }

  storeData(valuationId: number, isComplete: boolean, payload: any) {
    return this.http.post(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/valuation-process/${valuationId}`,
      {
        ...payload,
        isComplete
      },
      {
        headers: this.authService.getAuthHeaders()
      }
    )
  }
}